import ParkPointLoader from '../classes/loaders/ParkPointLoader';
import PolygonsLoader from '../classes/loaders/PolygonsLoader';

const polygonsLoader = new PolygonsLoader();
const parkPointLoader = new ParkPointLoader();

export default class BufferAdjustStore {
  public buffer: number = 3;
  public days: number = 1;

  public adjust(value: number) {
    this.buffer = value;
    polygonsLoader.adjustBuffer(this.buffer / 1000);
  }

  public changeDays(days: number) {
    this.days = days;
    parkPointLoader.changeDays(days);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/stores/BufferAdjustStore.ts